import React from 'react';
import { Username } from 'apps/components/shared';
import PropTypes from 'prop-types';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
export class PublishedBy extends React.Component {
  render() {
    const { spaceType, spacePath, creatorProfile } = this.props;
    if (creatorProfile) {
      const { username, content } = creatorProfile;
      const user = (
        <Username
          name='profile'
          params={{ profile: username }}
          content={content}
        >
          {{ username }}
        </Username>
      );
      const initiative = (
        <Username
          name='initiative'
          params={{ initiative: spacePath }}
          content={content}
        >
          {{ spacePath }}
        </Username>
      );
      const publishedBy = <Trans>Published by {user}</Trans>;
      const publishedByVia = (
        <Trans>
          Published by {initiative} via {user}
        </Trans>
      );
      return (
        <span>{spaceType === 'initiative' ? publishedByVia : publishedBy}</span>
      );
    }
    return null;
  }
}

PublishedBy.propTypes = {
  spaceType: PropTypes.string,
  spacePath: PropTypes.string,
  creatorProfile: PropTypes.object,
};
